import React from 'react';

export const ArbitrumLogo = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="#222222"
      />
      <path
        d="M9.33321 2.84155C9.74581 2.60837 10.2542 2.60837 10.6668 2.84155L16.0001 5.85566C16.4125 6.08876 16.6666 6.51946 16.6666 6.9856V13.0144C16.6666 13.4805 16.4125 13.9112 16.0001 14.1443L10.6668 17.1584C10.2542 17.3916 9.74581 17.3916 9.33321 17.1584L3.99991 14.1443C3.58747 13.9112 3.33337 13.4805 3.33337 13.0144V6.9856C3.33337 6.51946 3.58747 6.08876 3.99991 5.85566L9.33321 2.84155Z"
        fill="#96BEDC"
      />
      <path
        d="M9.79995 3.62337C9.93748 3.5456 10.107 3.5456 10.2445 3.62337L15.5223 6.60697C15.6597 6.68467 15.7444 6.82823 15.7444 6.98357V12.9512C15.7444 13.1065 15.6597 13.2501 15.5223 13.3278L10.2445 16.3114C10.107 16.3892 9.93748 16.3892 9.79995 16.3114L4.52218 13.3278C4.38475 13.2501 4.30005 13.1065 4.30005 12.9512V6.98357C4.30005 6.82823 4.38475 6.68467 4.52218 6.60697L9.79995 3.62337Z"
        fill="#222222"
      />
      <path
        d="M4.79691 14.5948L3.84531 14.057C3.52895 13.8782 3.33331 13.5429 3.33331 13.1795L6.90838 7.82596C7.29828 7.2421 7.96288 6.8902 8.67558 6.8902H9.70548L4.79691 14.5948Z"
        fill="white"
      />
      <path d="M7.06886 15.8788L5.35736 14.9115L10.3444 6.8902H12.5055L7.06886 15.8788Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0179 14.1782L12.121 15.2506L10.0555 12.0877L11.3221 10.0109L14.0179 14.1782ZM15.7444 12.0328V12.9512C15.7444 13.1065 15.6597 13.2501 15.5223 13.3278L14.5585 13.8726L11.6888 9.3639L12.7888 7.55893L15.7444 12.0328Z"
        fill="#28A0F0"
      />
    </svg>
  );
};
